import { Mutex } from 'async-mutex';
const mutex = new Mutex();

export default {
  methods: {
    async extendQueryString(...args) {
      const release = await mutex.acquire();
      try {
        // console.debug('extendQueryString..')
        const combineQuery = Object.assign({}, this.$route.query, ...args)
        const sortedQuery = Object.keys(combineQuery)
          .sort()
          .reduce((acc, key) => ({
            ...acc, [key]: combineQuery[key]
          }), {})
        // console.debug(this.$route.query)
        // console.debug(sortedQuery)
        if (!this.$_.isEqual(this.$route.query, sortedQuery)) {
          await new Promise((resolve, reject) => this.$router.push({ query: sortedQuery }, resolve, reject))
        }
      } finally {
        // console.debug('extendQueryString.. --- DONE');
        release();
      }
    },
    async extendQueryStringWithHash(hash, ...args) {
      const release = await mutex.acquire();
      try {
        // console.debug('extendQueryString..')
        const combineQuery = Object.assign({}, this.$route.query, ...args)
        const sortedQuery = Object.keys(combineQuery)
          .sort()
          .reduce((acc, key) => ({
            ...acc, [key]: combineQuery[key]
          }), {})
        // console.debug(this.$route.query)
        // console.debug(sortedQuery)
        if (!this.$_.isEqual(this.$route.query, sortedQuery)) {
          await new Promise((resolve, reject) => this.$router.push({ query: sortedQuery, hash }, resolve, reject))
        }
      } finally {
        // console.debug('extendQueryString.. --- DONE');
        release();
      }
    },

    async removeSingleQueryString(removeQueryKey) {
      const release = await mutex.acquire();
      try {
        // console.debug('removeSingleQueryString..')
        const { [removeQueryKey]: value, ...changedQuery } = this.$route.query;
        // console.debug(this.$route.query)
        // console.debug(changedQuery)
        if (!this.$_.isEqual(this.$route.query, changedQuery)) {
          await new Promise((resolve, reject) => this.$router.push({ query: changedQuery }, resolve, reject))
        }
      } finally {
        // console.debug('removeSingleQueryString.. --- DONE');
        release();
      }
    },
    async removeSingleQueryStringWithHash(hash, removeQueryKey) {
      const release = await mutex.acquire();
      try {
        // console.debug('removeSingleQueryString..')
        const { [removeQueryKey]: value, ...changedQuery } = this.$route.query;
        // console.debug(this.$route.query)
        // console.debug(changedQuery)
        if (!this.$_.isEqual(this.$route.query, changedQuery)) {
          await new Promise((resolve, reject) => this.$router.push({ query: changedQuery, hash }, resolve, reject))
        }
      } finally {
        // console.debug('removeSingleQueryString.. --- DONE');
        release();
      }
    },

    async updateQueryString(changedQuery) {
      const release = await mutex.acquire();
      try {
        // console.debug('updateQueryString...')
        if (!this.$_.isEqual(this.$route.query, changedQuery)) {
          await new Promise((resolve, reject) => this.$router.push({ query: changedQuery }, resolve, reject))
        }
      } finally {
        // console.debug('updateQueryString.. --- DONE');
        release();
      }
    }
  }
}